import React from 'react';
import styles from './Cover.module.scss';

const Cover = ({ src, children }) => {
  return (
    <div className={styles.root}>
      <img
        className={styles.cover}
        alt="Обрезанное изображение"
        src={src}
      />
      <div className={styles.btns}>{children}</div>
    </div>
  );
};

export default Cover;
